import { useRef, useEffect } from 'react'
import useWindowDimensions from "../../../hocs/useWindowDimensions";
import workspace from "./workspace";
import scale from "./controls/scale";
import sqftEventManager from "../store/sqftEventManager";
import sqftShapeManager from "../store/sqftShapeManager";
import tutorial from "./tutorial";
import $ from "jquery";

const SqftUseCanvas = (renderEvents, options={}, visualizersLoadedLength, fabricatorData, sqftVisited, intl) => {
  const canvasRef = useRef(null);
  const { windowWidth, windowHeight } = useWindowDimensions();

  useEffect(() => {
    sqftEventManager.clearAll();
    workspace.init($('#workspace'), intl);
    scale.init();
  }, [intl]);

  useEffect(() => {
    if(visualizersLoadedLength.length && !sqftVisited && fabricatorData.settings.showSqftTutorial) {
      tutorial.init()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[visualizersLoadedLength, sqftVisited, fabricatorData]);

  useEffect(() => {
    const updateRate = 1000 / 60; //ticks per second in miliseconds
    const canvas = canvasRef.current;

    canvas.width = windowWidth;
    canvas.height = windowHeight;

    const context = canvas.getContext(options.context || '2d');
    let frameCount = 0;
    let animationFrameId;

    const requestAnimFrame = (render) => {
      return  window.requestAnimationFrame(render) ||
        window.webkitRequestAnimationFrame(render) ||
        window.mozRequestAnimationFrame(render)    ||
        window.oRequestAnimationFrame(render)      ||
        window.msRequestAnimationFrame(render)     ||
        function(render){
          window.setTimeout(render, updateRate);
        };
    };
    const render = () => {
      frameCount++;
      renderEvents.sort((a, b) => {
        return parseFloat(b.priority) - parseFloat(a.priority);
      });
      renderEvents.forEach(renderTask => {
        renderTask.render.call(this, context, frameCount)
      });

      sqftShapeManager.shapes.forEach(shape => {
        shape.render.call(this, context)
      });

      sqftEventManager.trigger(sqftEventManager.events.RENDER);

      //EventManager.trigger(EventManager.events.RENDER); // this line re-renders canvas!

      // todo clear render
      //renderEvents = [];
      animationFrameId = requestAnimFrame(render)
    };
    render();

    return () => {
      window.cancelAnimationFrame(animationFrameId)
    }
  }, [renderEvents, options, windowHeight, windowWidth]);

  return canvasRef
};
export default SqftUseCanvas
